import script from "./sliderGamasUrbano.vue?vue&type=script&setup=true&lang=js"
export * from "./sliderGamasUrbano.vue?vue&type=script&setup=true&lang=js"

import "./sliderGamasUrbano.vue?vue&type=style&index=0&id=5519820d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5519820d"]])

export default __exports__